export default "__VITE_ASSET__BMTRitHm__"